import styled from '@emotion/styled';
import { TabList } from 'src/domains/common/components/tabs/tabs';

export const GlobalPageTabs = styled(TabList, { label: 'GlobalPageTabs' })`
    margin: var(--spacing-6, 24px) 0;
    width: max-content;
`;
